module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsItem"
  }, [_c('div', {
    staticClass: "wrapper-lg"
  }, [_c('div', {
    staticClass: "feed-title font-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69850e88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/CardNewsItem.vue
// module id = 1925
// module chunks = 18